module.exports = __webpack_public_path__ + "static/icons/back-imagen-2.43197b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/general/back-imagen-2.png
// module id = kbQO
// module chunks = 1